export default __webpack_public_path__ + "static/town-entrance-3e84d5d9a89065e8169bb149902694c0.jpeg";